import { AlertTriangle } from "lucide-react";
import type { UnfulfilledLever } from "@/types/ab-tests";

/**
 * AUT-357: levers the Variant B generator could not apply without fabricating a fact.
 * Shown in the Signal AI Rationale banner, above (and at least as prominent as) the
 * keyword-adjustment disclosure -- never buried beneath it.
 */
export function UnfulfilledLeversDisclosure({ levers }: { levers?: UnfulfilledLever[] | null }) {
  if (!levers || levers.length === 0) return null;

  return (
    <div
      data-testid="unfulfilled-levers-disclosure"
      className="space-y-1.5 rounded-md border border-status-warning-mid bg-status-warning-soft px-3 py-2.5"
    >
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 shrink-0 text-status-warning-strong" strokeWidth={2.5} />
        <p className="text-sm font-semibold text-foreground">
          {levers.length === 1
            ? "1 requested change couldn't be applied"
            : `${levers.length} requested changes couldn't be applied`}
        </p>
      </div>
      <ul className="space-y-1 pl-6 list-disc marker:text-status-warning-strong">
        {levers.map((lever, i) => (
          <li key={i} className="text-sm text-foreground">
            <span className="font-medium">{lever.requested || lever.lever_type}</span>
            {lever.reason && <span className="text-muted-foreground"> — {lever.reason}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}
